const ACCEPTED_AUDIO_TYPES = [".wav", ".mp3", ".m4a"]
export const ACCEPT_STRING = ACCEPTED_AUDIO_TYPES.join(",")
const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024
export const MAX_TRANSCRIPT_SIZE_BYTES = 5 * 1024 * 1024

export interface AudioFile {
  file: File
  id: string
  status: "pending" | "uploading" | "done" | "error"
  progress: number
  s3Key?: string
  s3Bucket?: string
  previewUrl?: string
  error?: string
  groundTruthTranscript?: string
}

export const getFileExtension = (name: string): string => {
  const parts = name.split(".")
  return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : ""
}

export const getMimeType = (ext: string): string => {
  switch (ext) {
    case "wav":
      return "audio/wav"
    case "mp3":
      return "audio/mpeg"
    case "m4a":
      return "audio/mp4"
    default:
      return "audio/wav"
  }
}

export const validateAudioFile = (file: File): string | null => {
  const ext = `.${getFileExtension(file.name)}`
  if (!ACCEPTED_AUDIO_TYPES.includes(ext)) {
    return `Unsupported file type: ${ext}. Accepted formats: ${ACCEPTED_AUDIO_TYPES.join(", ")}`
  }
  if (file.size > MAX_FILE_SIZE_BYTES) {
    return `File too large (${(file.size / 1024 / 1024).toFixed(1)} MB). Max size: ${MAX_FILE_SIZE_BYTES / 1024 / 1024} MB`
  }
  return null
}
